import React, { useMemo } from 'react';
import Head from 'next/head';
import { isMobile, isTablet } from 'react-device-detect';
import Login from '@components/activate/Login';
import MobileNotSupportedComponent from '@components/activate/MobileNotSupported';
import Main from '@components/Main';
import { useAuth } from '@context';

const ActivateBots = () => {
	const { loginFlag, loggedIn } = useAuth();

	// After the Discord OAuth redirect, web3auth (on prod) returns to /activate —
	// not /activate-login — because only /activate is an accepted redirect for the
	// prod client. It carries the session in the URL hash (#b64Params=...).
	// Detect it on the FIRST client render, before context.init() has set
	// loginFlag, so we show the loader immediately instead of flashing the
	// "Step 1" instructions. <Main/> then runs the account flow (getAccounts ->
	// setAccountInfo -> redirect to /activate-account) and shows the spinner
	// throughout. Captured once (useMemo) so it survives web3auth stripping the
	// hash during init. A normal (non-callback) visit shows the instructions.
	const isOauthCallback = useMemo(() => {
		if (typeof window === 'undefined') return false;
		return (window.location.hash + window.location.search).includes('b64Params');
	}, []);

	if (isMobile || isTablet) {
		return <MobileNotSupportedComponent />;
	}

	if (isOauthCallback || loginFlag || loggedIn) {
		return <Main />;
	}

	return (
		<>
			<Head>
				<title>Login</title>
			</Head>
			<Login />
		</>
	);
};

export default ActivateBots;
